import { render, staticRenderFns } from "./deliverydetail.vue?vue&type=template&id=11b05d0a&"
import script from "./deliverydetail.vue?vue&type=script&lang=js&"
export * from "./deliverydetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports